import { render } from "./CollapsibleList.vue?vue&type=template&id=b2377658&scoped=true"
import script from "./CollapsibleList.vue?vue&type=script&lang=js"
export * from "./CollapsibleList.vue?vue&type=script&lang=js"

import "./CollapsibleList.vue?vue&type=style&index=0&id=b2377658&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2377658"]])

export default __exports__